import * as Types from '../mutation-types'
import { set_one, set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '../mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_MANY]: set_many({ to: 'entities' }),
    [Types.SET_ONE]: set_one({ to: 'entities' }),

    REMOVE(state, { content }) {
        const entities = { ...state.entities }
        delete entities[content.id]
        state.entities = entities
    },

}
